import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { UserAccountRole } from '@shared/user/enums';
import { AuthUser } from '@shared/signup/models';
import { AuthRestaurantService } from '@tablesready/frontend-store';

@Injectable({providedIn: 'root'})
export class PermissionService {
  constructor(
    private readonly authRestaurantService: AuthRestaurantService,
  ) { }

  isAccountAdmin(user: AuthUser): boolean {
    return user?.accountUser?.role === UserAccountRole.admin;
  }

  userAccountHasScopes(user: AuthUser, scopes: string[], availableFor: UserAccountRole[]): boolean {
    const grantedScopes = user.locationUser?.scope.split(' ');

    if (scopes.length === 0 && availableFor.includes(UserAccountRole.user)) {
      return true;
    }

    return availableFor.includes(user.accountUser?.role) && !!scopes.find(scope => grantedScopes.includes(scope));
  }

  userAccountHasScopesAsync(scopes: string[], availableFor: UserAccountRole[]): Observable<boolean> {
    return this.authRestaurantService.select().pipe(
      map(user => {
        const grantedScopes = user.locationUser?.scope.split(' ');

        if (scopes.length === 0 && availableFor.includes(UserAccountRole.user)) {
          return true;
        }

        return availableFor.includes(user.accountUser?.role) && !!scopes.find(scope => grantedScopes.includes(scope));
      }),
    );
  }

  hasScopes(user: AuthUser, scopes: string[]): boolean {
    if (!user) {
      return false;
    }

    if (user.locationUser && scopes.length) {
      const grantedScopes = (user.locationUser.scope || '').split(' ');

      return !!scopes.find(scope => grantedScopes.indexOf(scope) >= 0);
    }

    return scopes.length === 0;
  }
}
